// search.proto — the three retrieval modes, kept as separate RPCs.
//
// They are genuinely different operations with different inputs, costs and
// failure modes: trigram lookup is cheap and always available; semantic and
// image search both depend on the embedder being reachable and on a backfill
// having run. Collapsing them into one "search" RPC would mean every caller
// handles "the vector half is degraded" on a path that never needed it.

// @generated by protoc-gen-es v2.13.0 with parameter "target=ts,import_extension=none"
// @generated from file amrec/v1/search.proto (package amrec.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Work } from "./catalog_pb";
import { file_amrec_v1_catalog } from "./catalog_pb";
import type { ContentRating, MediaFormat, TitleLanguage, WorkKind } from "./common_pb";
import { file_amrec_v1_common } from "./common_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file amrec/v1/search.proto.
 */
export const file_amrec_v1_search: GenFile = /*@__PURE__*/
  fileDesc("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", [file_amrec_v1_catalog, file_amrec_v1_common]);

/**
 * SearchFilters is the shared narrowing applied to every retrieval mode.
 *
 * @generated from message amrec.v1.SearchFilters
 */
export type SearchFilters = Message<"amrec.v1.SearchFilters"> & {
  /**
   * @generated from field: repeated amrec.v1.WorkKind kinds = 1;
   */
  kinds: WorkKind[];

  /**
   * @generated from field: repeated amrec.v1.MediaFormat formats = 2;
   */
  formats: MediaFormat[];

  /**
   * Defaults to SAFE when unset. Same rule as ListWorks: adult content is in
   * the index but never leaks into a default query.
   *
   * @generated from field: amrec.v1.ContentRating max_rating = 3;
   */
  maxRating: ContentRating;

  /**
   * @generated from field: int32 year_from = 4;
   */
  yearFrom: number;

  /**
   * @generated from field: int32 year_to = 5;
   */
  yearTo: number;

  /**
   * @generated from field: repeated string tag_ids = 6;
   */
  tagIds: string[];
};

/**
 * Describes the message amrec.v1.SearchFilters.
 * Use `create(SearchFiltersSchema)` to create a new message.
 */
export const SearchFiltersSchema: GenMessage<SearchFilters> = /*@__PURE__*/
  messageDesc(file_amrec_v1_search, 0);

/**
 * MatchedTitle explains *why* a work matched — which of its many titles hit,
 * and how well. Without this a result list looks arbitrary when the match came
 * from an obscure synonym rather than the display title.
 *
 * @generated from message amrec.v1.MatchedTitle
 */
export type MatchedTitle = Message<"amrec.v1.MatchedTitle"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;

  /**
   * @generated from field: amrec.v1.TitleLanguage language = 2;
   */
  language: TitleLanguage;

  /**
   * 0-1, trigram similarity
   *
   * @generated from field: double similarity = 3;
   */
  similarity: number;
};

/**
 * Describes the message amrec.v1.MatchedTitle.
 * Use `create(MatchedTitleSchema)` to create a new message.
 */
export const MatchedTitleSchema: GenMessage<MatchedTitle> = /*@__PURE__*/
  messageDesc(file_amrec_v1_search, 1);

/**
 * @generated from message amrec.v1.WorkHit
 */
export type WorkHit = Message<"amrec.v1.WorkHit"> & {
  /**
   * @generated from field: amrec.v1.Work work = 1;
   */
  work?: Work | undefined;

  /**
   * Final blended rank score. Not comparable across retrieval modes.
   *
   * @generated from field: double score = 2;
   */
  score: number;

  /**
   * @generated from field: amrec.v1.MatchedTitle matched_title = 3;
   */
  matchedTitle?: MatchedTitle | undefined;
};

/**
 * Describes the message amrec.v1.WorkHit.
 * Use `create(WorkHitSchema)` to create a new message.
 */
export const WorkHitSchema: GenMessage<WorkHit> = /*@__PURE__*/
  messageDesc(file_amrec_v1_search, 2);

/**
 * @generated from message amrec.v1.SearchWorksRequest
 */
export type SearchWorksRequest = Message<"amrec.v1.SearchWorksRequest"> & {
  /**
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * @generated from field: amrec.v1.SearchFilters filters = 2;
   */
  filters?: SearchFilters | undefined;

  /**
   * @generated from field: int32 page_size = 3;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 4;
   */
  pageToken: string;
};

/**
 * Describes the message amrec.v1.SearchWorksRequest.
 * Use `create(SearchWorksRequestSchema)` to create a new message.
 */
export const SearchWorksRequestSchema: GenMessage<SearchWorksRequest> = /*@__PURE__*/
  messageDesc(file_amrec_v1_search, 3);

/**
 * @generated from message amrec.v1.SearchWorksResponse
 */
export type SearchWorksResponse = Message<"amrec.v1.SearchWorksResponse"> & {
  /**
   * @generated from field: repeated amrec.v1.WorkHit hits = 1;
   */
  hits: WorkHit[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;
};

/**
 * Describes the message amrec.v1.SearchWorksResponse.
 * Use `create(SearchWorksResponseSchema)` to create a new message.
 */
export const SearchWorksResponseSchema: GenMessage<SearchWorksResponse> = /*@__PURE__*/
  messageDesc(file_amrec_v1_search, 4);

/**
 * SearchSemanticRequest takes natural language ("melancholy sci-fi about
 * memory") and embeds it, rather than matching tokens. Requires the text
 * embedding backfill; returns FAILED_PRECONDITION if no embeddings exist for
 * the active model.
 *
 * @generated from message amrec.v1.SearchSemanticRequest
 */
export type SearchSemanticRequest = Message<"amrec.v1.SearchSemanticRequest"> & {
  /**
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * @generated from field: amrec.v1.SearchFilters filters = 2;
   */
  filters?: SearchFilters | undefined;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit: number;

  /**
   * Pin a specific embedding model. Empty = server's active model. Present so
   * a new model can be evaluated against the old one on live data before it
   * becomes the default.
   *
   * @generated from field: string model_id = 4;
   */
  modelId: string;
};

/**
 * Describes the message amrec.v1.SearchSemanticRequest.
 * Use `create(SearchSemanticRequestSchema)` to create a new message.
 */
export const SearchSemanticRequestSchema: GenMessage<SearchSemanticRequest> = /*@__PURE__*/
  messageDesc(file_amrec_v1_search, 5);

/**
 * @generated from message amrec.v1.SearchSemanticResponse
 */
export type SearchSemanticResponse = Message<"amrec.v1.SearchSemanticResponse"> & {
  /**
   * @generated from field: repeated amrec.v1.WorkHit hits = 1;
   */
  hits: WorkHit[];

  /**
   * which model actually answered
   *
   * @generated from field: string model_id = 2;
   */
  modelId: string;
};

/**
 * Describes the message amrec.v1.SearchSemanticResponse.
 * Use `create(SearchSemanticResponseSchema)` to create a new message.
 */
export const SearchSemanticResponseSchema: GenMessage<SearchSemanticResponse> = /*@__PURE__*/
  messageDesc(file_amrec_v1_search, 6);

/**
 * @generated from message amrec.v1.MatchImageRequest
 */
export type MatchImageRequest = Message<"amrec.v1.MatchImageRequest"> & {
  /**
   * Raw image bytes. Server decodes, normalizes and hashes; it does not fetch
   * URLs on the caller's behalf (SSRF surface for no benefit).
   *
   * @generated from field: bytes image_data = 1;
   */
  imageData: Uint8Array;

  /**
   * @generated from field: amrec.v1.MatchMode mode = 2;
   */
  mode: MatchMode;

  /**
   * @generated from field: amrec.v1.SearchFilters filters = 3;
   */
  filters?: SearchFilters | undefined;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit: number;

  /**
   * @generated from field: string model_id = 5;
   */
  modelId: string;
};

/**
 * Describes the message amrec.v1.MatchImageRequest.
 * Use `create(MatchImageRequestSchema)` to create a new message.
 */
export const MatchImageRequestSchema: GenMessage<MatchImageRequest> = /*@__PURE__*/
  messageDesc(file_amrec_v1_search, 7);

/**
 * @generated from message amrec.v1.ImageMatch
 */
export type ImageMatch = Message<"amrec.v1.ImageMatch"> & {
  /**
   * @generated from field: amrec.v1.Work work = 1;
   */
  work?: Work | undefined;

  /**
   * @generated from field: double score = 2;
   */
  score: number;

  /**
   * Which signal produced this hit, so a caller can tell an exact-hash match
   * from a visual-similarity guess.
   *
   * @generated from field: amrec.v1.MatchMode matched_by = 3;
   */
  matchedBy: MatchMode;

  /**
   * Hamming distance when matched_by is PHASH; 0 for an exact match.
   *
   * @generated from field: int32 hamming_distance = 4;
   */
  hammingDistance: number;

  /**
   * Which volume's cover matched, when the hit came from per-volume cover art
   * rather than the work's primary cover. Empty means the primary cover.
   *
   * This is most of the value when identifying a photo taken in a shop: the
   * answer to "which manga is this" is the work, but "and it is volume 23" is
   * what tells you whether you already own it. Text, not an int, because
   * volumes are labelled "0", "13.5" and "Extra" as often as "1".
   *
   * @generated from field: string volume = 5;
   */
  volume: string;

  /**
   * The exact cover image that matched, for showing the user what was compared.
   *
   * @generated from field: string matched_cover_url = 6;
   */
  matchedCoverUrl: string;
};

/**
 * Describes the message amrec.v1.ImageMatch.
 * Use `create(ImageMatchSchema)` to create a new message.
 */
export const ImageMatchSchema: GenMessage<ImageMatch> = /*@__PURE__*/
  messageDesc(file_amrec_v1_search, 8);

/**
 * @generated from message amrec.v1.MatchImageResponse
 */
export type MatchImageResponse = Message<"amrec.v1.MatchImageResponse"> & {
  /**
   * @generated from field: repeated amrec.v1.ImageMatch matches = 1;
   */
  matches: ImageMatch[];

  /**
   * @generated from field: string query_phash = 2;
   */
  queryPhash: string;
};

/**
 * Describes the message amrec.v1.MatchImageResponse.
 * Use `create(MatchImageResponseSchema)` to create a new message.
 */
export const MatchImageResponseSchema: GenMessage<MatchImageResponse> = /*@__PURE__*/
  messageDesc(file_amrec_v1_search, 9);

/**
 * @generated from message amrec.v1.SuggestRequest
 */
export type SuggestRequest = Message<"amrec.v1.SuggestRequest"> & {
  /**
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * @generated from field: amrec.v1.SearchFilters filters = 2;
   */
  filters?: SearchFilters | undefined;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit: number;
};

/**
 * Describes the message amrec.v1.SuggestRequest.
 * Use `create(SuggestRequestSchema)` to create a new message.
 */
export const SuggestRequestSchema: GenMessage<SuggestRequest> = /*@__PURE__*/
  messageDesc(file_amrec_v1_search, 10);

/**
 * @generated from message amrec.v1.Suggestion
 */
export type Suggestion = Message<"amrec.v1.Suggestion"> & {
  /**
   * @generated from field: string work_id = 1;
   */
  workId: string;

  /**
   * @generated from field: string display_title = 2;
   */
  displayTitle: string;

  /**
   * @generated from field: string matched_text = 3;
   */
  matchedText: string;

  /**
   * @generated from field: amrec.v1.WorkKind kind = 4;
   */
  kind: WorkKind;

  /**
   * @generated from field: int32 year = 5;
   */
  year: number;

  /**
   * @generated from field: string cover_path = 6;
   */
  coverPath: string;
};

/**
 * Describes the message amrec.v1.Suggestion.
 * Use `create(SuggestionSchema)` to create a new message.
 */
export const SuggestionSchema: GenMessage<Suggestion> = /*@__PURE__*/
  messageDesc(file_amrec_v1_search, 11);

/**
 * @generated from message amrec.v1.SuggestResponse
 */
export type SuggestResponse = Message<"amrec.v1.SuggestResponse"> & {
  /**
   * @generated from field: repeated amrec.v1.Suggestion suggestions = 1;
   */
  suggestions: Suggestion[];
};

/**
 * Describes the message amrec.v1.SuggestResponse.
 * Use `create(SuggestResponseSchema)` to create a new message.
 */
export const SuggestResponseSchema: GenMessage<SuggestResponse> = /*@__PURE__*/
  messageDesc(file_amrec_v1_search, 12);

/**
 * MatchMode selects the tradeoff. PHASH answers "is this exact cover already
 * in the DB" (precise, cheap, brittle to crops); EMBEDDING answers "what looks
 * like this" (robust, fuzzy). AUTO tries pHash first and falls back — the
 * right default, because an exact cover re-upload should never be answered
 * with a vague vector neighbourhood.
 *
 * @generated from enum amrec.v1.MatchMode
 */
export enum MatchMode {
  /**
   * @generated from enum value: MATCH_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MATCH_MODE_AUTO = 1;
   */
  AUTO = 1,

  /**
   * @generated from enum value: MATCH_MODE_PHASH = 2;
   */
  PHASH = 2,

  /**
   * @generated from enum value: MATCH_MODE_EMBEDDING = 3;
   */
  EMBEDDING = 3,
}

/**
 * Describes the enum amrec.v1.MatchMode.
 */
export const MatchModeSchema: GenEnum<MatchMode> = /*@__PURE__*/
  enumDesc(file_amrec_v1_search, 0);

/**
 * @generated from service amrec.v1.SearchService
 */
export const SearchService: GenService<{
  /**
   * @generated from rpc amrec.v1.SearchService.SearchWorks
   */
  searchWorks: {
    methodKind: "unary";
    input: typeof SearchWorksRequestSchema;
    output: typeof SearchWorksResponseSchema;
  },
  /**
   * @generated from rpc amrec.v1.SearchService.SearchSemantic
   */
  searchSemantic: {
    methodKind: "unary";
    input: typeof SearchSemanticRequestSchema;
    output: typeof SearchSemanticResponseSchema;
  },
  /**
   * @generated from rpc amrec.v1.SearchService.MatchImage
   */
  matchImage: {
    methodKind: "unary";
    input: typeof MatchImageRequestSchema;
    output: typeof MatchImageResponseSchema;
  },
  /**
   * @generated from rpc amrec.v1.SearchService.Suggest
   */
  suggest: {
    methodKind: "unary";
    input: typeof SuggestRequestSchema;
    output: typeof SuggestResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_amrec_v1_search, 0);

